export { default } from '@telexpress_auth/vue-dialogue-quality-management';
